import { isPhone } from '@/common/validators';

export default {
  data() {
    return {
      phoneError: '',
    };
  },
  methods: {
    validatePhone(e) {
      const phone = e?.target?.value || e?.value || null;
      this.phoneError = '';
      if (!phone) {
        this.phoneError = 'This field is required.';
        return;
      }
      const isValid = isPhone(phone);
      if (!isValid) this.phoneError = 'Please enter a valid phone number.';
    },
    validateEuroPhone(e, val) {
      const phone = e?.target?.value || e?.value || null;
      this.phoneError = '';
      if (!phone) {
        this.phoneError = 'This field is required.';
        return;
      }
      const isValid = val;
      if (!isValid) this.phoneError = 'Please enter a valid phone number.';
    },
  },
};
